const topbar = {
    docs: 'Documentação',
    help: 'Ajuda',
};
export default Object.freeze(topbar);
